export default "__VITE_ASSET__Bc4ZPt5D__"